var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "smesco-fee-setting"
  }, [_c('div', {
    staticClass: "flex justify-between items-center pb-6 shadow-border-b mdmax:flex-col mdmax:gap-2"
  }, [_c('div', {
    staticClass: "flex-1 flex justify-end items-center gap-2 mdmax:flex-auto mdmax:w-full"
  }, [_c('LinkButton', {
    attrs: {
      "buttonText": "Tambah Fee Setting",
      "url": "/smesco/fee-setting/create",
      "linkType": "internal",
      "size": _vm.isMobile ? 'full' : 'regular'
    }
  })], 1)]), _c('TableComponent', {
    attrs: {
      "columns": _vm.columns,
      "list": _vm.feeSettings
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function (_ref) {
        var entry = _ref.entry,
            column = _ref.column;
        return [column.field === 'action' ? _c('div', {
          staticClass: "flex gap-2"
        }, [_c('LinkButton', {
          attrs: {
            "buttonText": "Edit",
            "url": `/smesco/fee-setting/edit/${entry.id}`,
            "linkType": "internal",
            "type": "secondary",
            "size": "small"
          }
        }), _c('Button', {
          attrs: {
            "buttonText": "Delete",
            "type": "delete",
            "size": "small"
          },
          on: {
            "action": function ($event) {
              return _vm.confirmDelete(entry.id);
            }
          }
        })], 1) : column.field === 'fixed_fee' ? _c('span', [_vm._v(" " + _vm._s(entry[column.field] > 0 ? `Rp ${Number(entry[column.field]).toLocaleString('id-ID')}` : '-') + " ")]) : column.field === 'percentage_fee' ? _c('span', [_vm._v(" " + _vm._s(entry[column.field] > 0 ? `${entry[column.field]}%` : '-') + " ")]) : _c('span', [_vm._v(_vm._s(entry[column.field] || '-'))])];
      }
    }])
  }), !_vm.isMobile ? _c('div', {
    staticClass: "text-neutral-500 font-medium mt-2 text-sm"
  }, [_vm._v("Menampilkan " + _vm._s(_vm.start) + " - " + _vm._s(_vm.end) + " dari " + _vm._s(_vm.totalRecords))]) : _vm._e(), _vm.feeSettings && _vm.feeSettings.length > 0 ? _c('div', {
    staticClass: "mt-8 flex justify-center items-center mb-6"
  }, [_c('pagination', {
    attrs: {
      "currentPage": _vm.currentPage,
      "totalCount": _vm.totalRecords,
      "pageSize": _vm.pageSize
    },
    on: {
      "onPageChange": _vm.onPageChange
    }
  })], 1) : _vm._e(), _c('Modal', {
    attrs: {
      "modalVisible": _vm.deleteModalVisible,
      "width": "400px"
    },
    on: {
      "close": _vm.closeDeleteModal
    }
  }, [_c('div', {
    staticClass: "text-center",
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('h3', {
    staticClass: "text-lg font-bold text-neutral-800 mb-2"
  }, [_vm._v("Hapus Fee Setting")]), _c('p', {
    staticClass: "text-neutral-600 mb-6"
  }, [_vm._v(" Apakah Anda yakin ingin menghapus data ini? ")]), _c('div', {
    staticClass: "flex justify-center gap-3"
  }, [_c('button', {
    staticClass: "px-4 py-2 rounded-lg border border-neutral-300 text-neutral-600 hover:bg-neutral-50 font-medium",
    on: {
      "click": _vm.closeDeleteModal
    }
  }, [_vm._v(" Batal ")]), _c('button', {
    staticClass: "px-4 py-2 rounded-lg bg-red-500 text-white hover:bg-red-600 font-medium",
    on: {
      "click": _vm.deleteItem
    }
  }, [_vm._v(" Hapus ")])])])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }